import { render, staticRenderFns } from "./SumupResultRankListTotal.vue?vue&type=template&id=1387518e&scoped=true&"
import script from "./SumupResultRankListTotal.vue?vue&type=script&lang=ts&"
export * from "./SumupResultRankListTotal.vue?vue&type=script&lang=ts&"
import style0 from "./SumupResultRankListTotal.vue?vue&type=style&index=0&id=1387518e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387518e",
  null
  
)

export default component.exports